var $ad554bf414b67ac3$exports = {};
$ad554bf414b67ac3$exports = {
    "collapse": `Skjul`,
    "expand": `Udvid`
};


export {$ad554bf414b67ac3$exports as default};
//# sourceMappingURL=da-DK.mjs.map
